import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Card, Grid, Typography } from "@mui/material";
import CircularLoader from "../../components/circularLoader";
import Label from "../../components/Label";
import { parseDate } from "../../utils/tableFunctions";
import { getBankAccountDetails } from "../../services/services";

const BankAccountDetailsCard = ({ itemId }) => {
    const [details, setDetails] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const { id = itemId } = useParams();

    useEffect(() => {
        getBankAccountDetails(id, setDetails, setLoaded);
    }, [id]);

    if (!loaded) {
        return <CircularLoader />;
    }

    if (!details) {
        return (
            <Container>
                <Typography variant="h6" color="error">
                    Failed to load Bank Account details
                </Typography>
            </Container>
        );
    }

    // build list field (display order)
    const fields = [
        { label: "Account Number", value: details.account_number },
        { label: "Bank Name", value: details.bank },
        { label: "Bank Country", value: details.bank_country },
        { label: "BIC/SWIFT Code", value: details.bic_swift_code },
        { label: "Bank Transfer Fee", value: details.bank_transfer_fee },
        { label: "Beneficiary Address", value: details.beneficiary_address },
        { label: "Beneficiary Branch Code", value: details.beneficiary_branch_code },
        { label: "Intermediary Bank Code", value: details.intermediary_bank_code },
        { label: "Active", value: details.is_active, type: "boolean" },
        
        { label: "Account Name", value: details.account_name },
        { label: "Bank Address", value: details.bank_address },
        { label: "Bank Branch Code", value: details.bank_branch_code },
        { label: "IBAN", value: details.iban },
        { label: "Beneficiary Name", value: details.beneficiary_name },
        { label: "Beneficiary Bank Code", value: details.beneficiary_bank_code },
        { label: "Intermediary Bank", value: details.intermediary_bank },
        { label: "Intermediary Name", value: details.intermediary_name },
        { label: "Settlement Fee", value: details.settlement_fee },
    ];

    // divive into 2 columns
    const mid = Math.ceil(fields.length / 2);
    const leftFields = fields.slice(0, mid);
    const rightFields = fields.slice(mid);

    const renderRow = (field, idx) => {
        const { label, value, type } = field;
        const display =
            type === "boolean"
                ? (
                    <Label variant="ghost" color={value ? "success" : "error"}>
                        {value ? "YES" : "NO"}
                    </Label>
                )
                : (value !== null && value !== undefined && value !== "" ? value : "N/A");

        return (
            <Grid item xs={12} key={idx}>
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={5}>
                        <Typography variant="subtitle1">{label}</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography variant="body1" component="div">
                            {display}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <Container>
            {/* Header */}
            <Typography variant="h4" gutterBottom>
                Bank Account Details
            </Typography>

            <Card sx={{ p: 3, mb: 3 }}>
                <Grid container spacing={2}>
                    {/* Left column */}
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            {leftFields.map((f, i) => renderRow(f, i))}
                        </Grid>
                    </Grid>

                    {/* Right column */}
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            {rightFields.map((f, i) => renderRow(f, i + mid))}
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
        </Container>
    );
};

export default BankAccountDetailsCard;
